module.exports = __webpack_public_path__ + "img/wx.cee65cbf.png";